// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Twnslgf_Ti0WwwbK73D2{align-items:center;height:100%;display:flex}.Twnslgf_Ti0WwwbK73D2 .SNl1cVABVN0LKLVyiYaP{margin:8px}.Twnslgf_Ti0WwwbK73D2 .kpxs5NZuxM8TuG_BYID3{align-items:center;width:28px;margin:0 8px 0 16px;display:flex;position:relative}.Twnslgf_Ti0WwwbK73D2 .kpxs5NZuxM8TuG_BYID3 .SNl1cVABVN0LKLVyiYaP{border:2px var(--background-primary-inverted-primary)solid;border-radius:8px;margin-left:0;display:block;position:absolute}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Twnslgf_Ti0WwwbK73D2`,
	"avatar": `SNl1cVABVN0LKLVyiYaP`,
	"avatars": `kpxs5NZuxM8TuG_BYID3`
};
export default ___CSS_LOADER_EXPORT___;
